// Map language names to icon paths for project display
const languageIconMap = {
  HTML: `${process.env.PUBLIC_URL}/images/icons/html.png`,
  CSS: `${process.env.PUBLIC_URL}/images/icons/css.png`,
  SASS: `${process.env.PUBLIC_URL}/images/icons/sass.png`,
  JavaScript: `${process.env.PUBLIC_URL}/images/icons/js.png`,
  PHP: `${process.env.PUBLIC_URL}/images/icons/php.png`,
  Python: `${process.env.PUBLIC_URL}/images/icons/python.png`,
  Laravel: `${process.env.PUBLIC_URL}/images/icons/laravel.png`,
  React: `${process.env.PUBLIC_URL}/images/icons/react.png`,
  Angular: `${process.env.PUBLIC_URL}/images/icons/angular.png`,
  MySQL: `${process.env.PUBLIC_URL}/images/icons/mysql.png`,
  MongoDB: `${process.env.PUBLIC_URL}/images/icons/MongoDB.png`,
  PostgreSQL: `${process.env.PUBLIC_URL}/images/icons/postgresql.png`,
  Bootstrap: `${process.env.PUBLIC_URL}/images/icons/bootstrap.png`,
  Tailwind: `${process.env.PUBLIC_URL}/images/icons/tailwind.png`,
  Java: `${process.env.PUBLIC_URL}/images/icons/java.png`,
  OpenCV: `${process.env.PUBLIC_URL}/images/icons/opencv.png`,
  AI: `${process.env.PUBLIC_URL}/images/icons/ai.png`,
  Jupyter: `${process.env.PUBLIC_URL}/images/icons/jupyter.png`,
  Yolo: `${process.env.PUBLIC_URL}/images/icons/yolo.png`,
  Gemini: `${process.env.PUBLIC_URL}/images/icons/gemini.png`,
  API: `${process.env.PUBLIC_URL}/images/icons/api.png`,
  FastAPI: `${process.env.PUBLIC_URL}/images/icons/fastapi.png`,
  Livewire: `${process.env.PUBLIC_URL}/images/icons/livewire.png`,
  Postman: `${process.env.PUBLIC_URL}/images/icons/postman.jpeg`,
  Swagger: `${process.env.PUBLIC_URL}/images/icons/swagger.png`,
  jQuery: `${process.env.PUBLIC_URL}/images/icons/jquery.png`,
  NodeJs: `${process.env.PUBLIC_URL}/images/icons/nodejs.png`,
  ExpressJs: `${process.env.PUBLIC_URL}/images/icons/ExpressJs.png`,
  Docker: `${process.env.PUBLIC_URL}/images/icons/docker.png`,
};

export default languageIconMap;
